<script>
import API from "@/api";
import ratingFormatter from "@/utils/formatters/rating";
import dateMixin from "@/mixins/dateMixin";

export default {
  mixins: [dateMixin],

  data() {
    return {
      professional: null
    };
  },

  methods: {
    async getProfessionalInfo() {
      try {
        this.professional = await API.Professionals.getMeta(
          this.$route.params.id
        );

        window.document.title = this.title;
        this.setMetaImage(this.image);
        this.setMetaDescription(this.content);
      } catch (e) {
        console.log(e);
      }
    },
    setMetaImage(imageUrl) {
      const url = imageUrl.replace("upload/", "upload/c_fill,h_100,w_100/");

      let metaImage = document.querySelector('meta[property="og:image"]');
      if (metaImage) {
        metaImage.setAttribute("content", url);
      } else {
        metaImage = document.createElement("meta");
        metaImage.setAttribute("property", "og:image");
        metaImage.setAttribute("content", url);
        document.head.appendChild(metaImage);
      }
    },

    setMetaDescription(description) {
      let metaDescription = document.querySelector(
        'meta[property="og:description"]'
      );
      if (metaDescription) {
        metaDescription.setAttribute("content", description);
      } else {
        metaDescription = document.createElement("meta");
        metaDescription.setAttribute("property", "og:description");
        metaDescription.setAttribute("content", description);
        document.head.appendChild(metaDescription);
      }
    }
  },

  computed: {
    title: function() {
      let title = `Donamaid | ${this.professional.fullname}`;

      if (this.professional.rating)
        title += ` • ${ratingFormatter.intToRating(
          this.professional.rating
        )} ⭐️`;

      return title;
    },
    image: function() {
      return this.professional.profile_picture;
    },
    content: function() {
      return `${
        this.professional.cleanings
      } limpeza(s), desde ${this.$options.filters.formatDate(
        this.professional.register_at,
        "MM/YYYY"
      )} • ${this.professional.description}`;
    }
  },

  async beforeMount() {
    await this.getProfessionalInfo();
  }
};
</script>


<template>
  <div class="container root" ref="container">
    <div class="left">
      <div>
        <h1>
          Baixe o nosso novo aplicativo.
        </h1>
      </div>

      <div>

        <div class='imgs'>
          <div>
            <p>
              Tenha acesso direto ao perfil do profissional, receba promoções, novidades e muito mais.
            </p>

            <img src="../../../static/dashboard/app.svg" width="120">
          </div>
          <img src="../../../static/app-2.png" class="mobile-img">
        </div>

      </div>
    </div>

    <div class="right">
      <img src="../../../static/app-2.png" class="desktop-img">
    </div>
  </div>
</template>

<style scoped>
.content-wrapper {
  background-color: #fff;
}
.root {
  max-width: 600px;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.mobile-img,
.desktop-img {
  width: 100%;
  max-width: 250px;
  display: block;
}

.mobile-img {
  margin-left: 24px;
  max-width: 200px;
}

.desktop-img {
  display: none;
  max-width: 350px;
}

.imgs {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-evenly;
}

@media (min-width: 600px) {
  .mobile-img {
    display: none;
  }

  .desktop-img {
    display: block;
  }

  .imgs {
    display: block;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/app/Index.vue